export interface VisitReviewCopy {
    stepIndicator: string
    heading: string
    priceLine: string
    actionTotal: string
    confirmAction: string
}

export interface VisitHealthHistoryConsentCopy {
    heading: string
    body: string
    allowAction: string
    manualAction: string
}

export interface VisitOptionsCopy {
    unavailableHeading: string
    unavailableBody: string
    unavailableAction: string
    unavailableActionDetailPrefix: string
    billingHeading: string
    inNetworkHeading: string
    inNetworkCashCheaperHeading: string
    outOfNetworkMultipleHeading: string
    outOfNetworkMultipleBody: string
    outOfNetworkSingleHeading: string
    optionsBody: string
    seeAllTimesAction: string
    continueAction: string
    careOptionsLink: string
}

export interface VisitScheduleCopy {
    heading: string
    rescheduleHeading: string
    checkoutAction: string
    rescheduleAction: string
    selectionPrompt: string
    showSwitchToChat: boolean
    useRefreshedTimeslotPicker: boolean
    slotTimeFormat: string
    dayLabelFormats: { weekday: string; date: string } | null
    afterTimeHeldPath: string
}

export interface VisitCheckoutCopy {
    showFeePolicy: boolean
    showPriceGuaranteeFooter: boolean
    partnerLine: string
    partnerName: string
    partnerWordmarkUrl: string
    eligibilityLabel: string
    actionTotal: string
}

export interface VisitCopy {
    options: VisitOptionsCopy
    schedule: VisitScheduleCopy
    review: VisitReviewCopy
    checkout: VisitCheckoutCopy
    healthHistoryConsent: VisitHealthHistoryConsentCopy
}

export const generalMedicineVisitCopy: VisitCopy = {
    options: {
        unavailableHeading: 'In-network clinicians are fully booked',
        unavailableBody:
            "No one covered by your Medicaid plan has availability in the next 2 weeks. Text us — and we'll help you find a time that works.",
        unavailableAction: 'Text us',
        unavailableActionDetailPrefix: 'Available today until ',
        billingHeading: 'Choose billing',
        inNetworkHeading: 'Good news! Your insurance is in-network.',
        inNetworkCashCheaperHeading: 'Your insurance is in-network, but you may save without insurance.',
        outOfNetworkMultipleHeading: "We're not in network with your plan. How would you like to proceed?",
        outOfNetworkMultipleBody: 'You can still book a video without insurance, or switch to a chat visit.',
        outOfNetworkSingleHeading: "We're not in network with your plan, but you can still book a visit.",
        optionsBody: '',
        seeAllTimesAction: 'See all options',
        continueAction: 'Continue',
        careOptionsLink: '',
    },
    schedule: {
        heading: 'Schedule visit',
        rescheduleHeading: 'Reschedule visit',
        checkoutAction: 'Go to checkout',
        rescheduleAction: 'Reschedule visit',
        selectionPrompt: '',
        showSwitchToChat: true,
        useRefreshedTimeslotPicker: false,
        slotTimeFormat: 'h:mm aaa',
        dayLabelFormats: null,
        afterTimeHeldPath: '/visit/{visitId}/payment/',
    },
    review: {
        stepIndicator: 'Book {visitType} visit',
        heading: 'Review & confirm',
        priceLine: '$0.00 visit cost',
        actionTotal: '',
        confirmAction: 'Book {visitType} visit',
    },
    checkout: {
        showFeePolicy: true,
        showPriceGuaranteeFooter: true,
        partnerLine: '',
        partnerName: '',
        partnerWordmarkUrl: '',
        eligibilityLabel: 'FSA / HSA eligible',
        actionTotal: '',
    },
    healthHistoryConsent: {
        heading: '',
        body: '',
        allowAction: '',
        manualAction: '',
    },
}

export const withVisitType = (template: string, visitType: string) =>
    template.replaceAll('{visitType}', () => visitType)

export const withTotal = (template: string, total: string) => template.replaceAll('{total}', () => total)
